import { MoSelect } from '@motivo/guanyin/src/components';
import { useQueryParams } from '@motivo/guanyin/src/hooks/useQueryParams';
import { MenuItem } from '@mui/material';
import React from 'react';

export default function SupervisorTypeFilter() {
  const { queryParams, updateQueryParams } = useQueryParams();

  return (
    <MoSelect
      name="supervisorType"
      label="Supervisor type"
      value={(queryParams.supervisorType as string) || ''}
      onChange={(e) => {
        updateQueryParams({ supervisorType: (e.target.value as string) || '', page: '1' }, true);
      }}
    >
      <MenuItem value="">All supervisors</MenuItem>
      <MenuItem value="EXTERNAL">Motivo only</MenuItem>
      <MenuItem value="INTERNAL">Non-Motivo only</MenuItem>
    </MoSelect>
  );
}
